module.exports = __webpack_public_path__ + "img/motorbikeRearRightOutline.aef36059.svg";